<template>

  <header class="tes-articles-main__header container">
    <MainPostSearchForm/>
    <h1 class="tes-articles-main__head tes-articles-main__head_1">Официальный блог ТИОН</h1>
  </header>

  <section class="tes-articles-main__section tes-articles-main__first-section container">
    <MasonryListEntityGridView tid="first-block-posts" :gridVersion="1"/>
  </section>

  <section class="tes-articles-main__section tes-articles-main__news-section container-fluid">
    <h2 class="tes-articles-main__head tes-articles-main__head_2">Новости</h2>
    <div class="tes-articles-main__news-wrapper bg-blue-05">
      <div class="tes-articles-main__news-container container">

<!--        <div class="tes-articles-main__news-item">-->
<!--          <a href="https://tion.ru/promo/carousel/?utm_source=blog&utm_medium=banner&utm_campaign=article"-->
<!--             title="Карусель впечатлений"-->
<!--             class="tes-articles-main__news-item-link">-->

<!--            <figure class="tes-articles-main__picture-container tes-picture__container">-->
<!--                <span class="tes-picture__overlay">-->
<!--                  <PuffSpinner class="tes-picture__spinner"/>-->
<!--                </span>-->
<!--              <picture class="tes-picture__wrapper">-->
<!--                <img src="https://storage.yandexcloud.net/cdn.tion.ru/images/2024/03/banner-66-263_170.jpg" width="263" height="170"-->
<!--                     alt="Карусель впечатлений"-->
<!--                     class="tes-articles-main__news-item-img tes-picture__image"/>-->
<!--              </picture>-->

<!--            </figure>-->

<!--            <h3 class="tes-articles-main__news-item-title"><span>Карусель впечатлений</span></h3>-->
<!--          </a>-->
<!--        </div>-->


        <!--<div class="tes-articles-main__news-item">
          <a href="https://tion.ru/shop/iris/?utm_source=blog&utm_medium=banner"
             title="Товар месяца - TION Iris"
             class="tes-articles-main__news-item-link">

            <figure class="tes-articles-main__picture-container tes-picture__container">
                <span class="tes-picture__overlay">
                  <PuffSpinner class="tes-picture__spinner"/>
                </span>
              <picture class="tes-picture__wrapper">
                <img src="https://storage.yandexcloud.net/cdn.tion.ru/images/2025/01/banner-87-263_170.jpg" width="263" height="170"
                     alt="Товар месяца - TION Iris"
                     class="tes-articles-main__news-item-img tes-picture__image"/>
              </picture>

            </figure>

            <h3 class="tes-articles-main__news-item-title"><span>Товар месяца - TION Iris</span></h3>
          </a>
        </div>-->

<!--        <div class="tes-articles-main__news-item">
          <a href="https://tion.ru/shop/iris/?utm_source=blog&utm_medium=banner"
             title="Товар месяца - Iris"
             class="tes-articles-main__news-item-link">

            <figure class="tes-articles-main__picture-container tes-picture__container">
                <span class="tes-picture__overlay">
                  <PuffSpinner class="tes-picture__spinner"/>
                </span>
              <picture class="tes-picture__wrapper">
                <img src="https://storage.yandexcloud.net/cdn.tion.ru/images/2025/03/banner-92-263_170.jpg" width="263" height="170"
                     alt="Товар месяца - Iris"
                     class="tes-articles-main__news-item-img tes-picture__image"/>
              </picture>

            </figure>

            <h3 class="tes-articles-main__news-item-title"><span>Товар месяца - Iris</span></h3>
          </a>
        </div>-->

        <div class="tes-articles-main__news-item">
          <a href="https://tion.ru/promo/spring-warming/?utm_source=blog&utm_medium=banner"
             title="Весенний прогрев до -15%"
             class="tes-articles-main__news-item-link">

            <figure class="tes-articles-main__picture-container tes-picture__container">
                <span class="tes-picture__overlay">
                  <PuffSpinner class="tes-picture__spinner"/>
                </span>
              <picture class="tes-picture__wrapper">
                <img src="https://storage.yandexcloud.net/cdn.tion.ru/images/2025/04/banner-94-263_170.jpg" width="263" height="170"
                     alt="Весенний прогрев до -15%"
                     class="tes-articles-main__news-item-img tes-picture__image"/>
              </picture>

            </figure>

            <h3 class="tes-articles-main__news-item-title"><span>Весенний прогрев до -15%</span></h3>
          </a>
        </div>

        <div class="tes-articles-main__news-item">
          <a href="https://tion.ru/promo/duo/?utm_source=blog&utm_medium=banner"
             title="Выгодный дуэт!"
             class="tes-articles-main__news-item-link">

            <figure class="tes-articles-main__picture-container tes-picture__container">
                <span class="tes-picture__overlay">
                  <PuffSpinner class="tes-picture__spinner"/>
                </span>
              <picture class="tes-picture__wrapper">
                <img src="https://storage.yandexcloud.net/cdn.tion.ru/images/2025/03/banner-93-263_170.jpg" width="263" height="170"
                     alt="Выгодный дуэт!"
                     class="tes-articles-main__news-item-img tes-picture__image"/>
              </picture>

            </figure>

            <h3 class="tes-articles-main__news-item-title"><span>Выгодный дуэт!</span></h3>
          </a>
        </div>

      </div>
    </div>
  </section>

  <div class="tes-articles-main__section tes-articles-main__banner-section container">
    <figure class="tes-picture__container">
      <span class="tes-picture__overlay">
        <PuffSpinner class="tes-picture__spinner"/>
      </span>
      <a href="https://tion.ru/product/breezer/"
         class="img-blog-banner"
         title="Бризеры TION">
        <picture class="tes-picture__wrapper">
          <!-- source srcset="/src/assets/bpage/banner.jpg?webp" -->
          <img src="https://vapt-storage.storage.yandexcloud.net/images/2021/12/banner.jpg" width="1111" height="187" alt="Бризеры TION"
               class="tes-picture__image"/>
        </picture>
      </a>
    </figure>
  </div>

  <section class="tes-articles-main__section tes-articles-main__popular-section container">
    <h2 class="tes-articles-main__head tes-articles-main__head_2">Популярные статьи</h2>
    <MasonryListEntityGridView tid="popular-block-posts" :gridVersion="2"/>
    <div class="tes-articles-main__section-footer">
      <router-link :to="`/tag/popular/`" class="tes-articles-main__section-more-link">Показать больше</router-link>
    </div>
  </section>

  <Carousel class="tes-articles-main__section tes-articles-main__tags-section bg-blue-05"
            :settings="carouselSettings"
            :breakpoints="carouselBreakpoints"
            v-if="tags.length > 0">
    <CarouselSlide v-for="(tag,index) in tags" :key="index">
      <div :class="['tes-articles-main__tag-panel', `tes-articles-main__tag-panel_${getColor(index)}`]">
        <h3 class="tes-articles-main__tag-panel-title">
          <router-link :to="{name: 'BlogTag', params: {tid: tag.tid}}"
                       class="tes-articles-main__tag-panel-title-link">#{{ tag.title }}
          </router-link>
        </h3>
        <router-link :to="{name: 'BlogPost', params: {tid: post.tid}}"
                     class="tes-articles-main__tag-panel-link"
                     v-for="post in tag.items">{{ post.header }}
        </router-link>
      </div>

    </CarouselSlide>


    <template #addons="{ slidesCount }">
      <!-- CarouselNav/ -->
      <CarouselPagination/>
    </template>
  </carousel>

  <section class="tes-articles-main__section tes-articles-main__last-posts container">
    <h2 class="tes-articles-main__head tes-articles-main__head_2">Последние статьи</h2>

    <MasonryLastPostsView/>

    <div class="tes-articles-main__section-footer">
      <router-link :to="{name: 'BlogList', params: {pageNum: 1}}" class="tes-articles-main__section-more-link">Показать
        больше
      </router-link>
      <div class="tes-articles-main__pagination tes-articles-main__pagination_popular">
        <router-link :to="{name: 'BlogList', params: {pageNum: number}}"
                     class="tes-articles-main__pagination-item" v-for="number in [1,2,3,4,5,6]">{{ number }}
        </router-link>
        <router-link :to="{name: 'BlogList', params: {pageNum: 7}}"
                     class="tes-articles-main__pagination-item">→
        </router-link>
      </div>
    </div>

  </section>

</template>

<script lang="ts">
import {PostTagData} from '../../objects/post/PostTag'
import {
  defaultPageBlogHeads, pageHeadersStateSymbol, PageHeadsStore,
  prepareHead
} from '../../states/page-heads'
import {useStore} from 'vuex'
import {defineComponent, inject, onMounted, onServerPrefetch, ref} from 'vue'
import MasonryListEntityGridView from '../../components/list-entity/MasonryListEntityGridView.vue'
import MainPostSearchForm from '../../components/post/MainPostSearchForm.vue'
import MasonryLastPostsView from '../../components/post/MasonryLastPostsView.vue'

import {
  Carousel, Slide as CarouselSlide, Pagination as CarouselPagination/*, Navigation as CarouselNav*/
} from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'

import PuffSpinner from '~/assets/loaders/puff.svg'


export default defineComponent({
  name: 'PageBlog',
  components: {
    MasonryListEntityGridView,
    MasonryLastPostsView,
    MainPostSearchForm,
    PuffSpinner,
    Carousel, CarouselSlide, CarouselPagination/*, CarouselNav*/
  },
  setup() {
    const store = useStore()
    const head: PageHeadsStore | undefined = inject(pageHeadersStateSymbol)

    if (head) {
      head.updateHead(prepareHead([defaultPageBlogHeads]))
    }

    // TAGS FOR MAIN
    let itemsTagsToShow = ref(4)
    const tags = ref([] as Array<PostTagData>)
    const loadTags = () => {

      return store.dispatch('postsTags/loadDataForTags',{props: {posts_per_tag: 4}, paginator: null, sort: null, filter: {tids: ['ventilyaciya', 'shum', 'duhota', 'ochistka-vozduha']}}, { root: true })
        .then(data => {
          data.forEach(tagData => {
            try {
              tags.value.push(tagData)
            } catch (e) {
              console.log(e)
            }
          })
        })
        .catch(e => console.log(e))
    }

    const getColor = (idx: number): string => {
      return ['blue', 'green', 'brown', 'darkgreen'][idx % 4]
    }

    onMounted(() => {
      loadTags()
    })

    onServerPrefetch(() => {
      return loadTags()
    })
    const carouselSettings = {itemsToShow: 1, snapAlign: "center"}
    // breakpoints are mobile first
    // any settings not specified will fallback to the carousel settings
    const carouselBreakpoints = {
      // 440px and up
      440: {itemsToShow: 1.5, snapAlign: "start"},
      // 600px and up
      600: {itemsToShow: 2, snapAlign: "start"},
      // 768px and up
      768: {itemsToShow: 2.5, snapAlign: "start"},
      // 880px and up
      880: {itemsToShow: 3, snapAlign: "start"},
      // 1180px and up
      1180: {itemsToShow: 3.5, snapAlign: "start"},
      // 1200 and up
      1200: {itemsToShow: 4, snapAlign: "start"},
    }
    return {
      tags,
      carouselSettings,
      carouselBreakpoints,
      itemsTagsToShow,
      getColor
    }
  }
})
</script>

<style lang="scss">

/* CAROUSEL */
.carousel {
  &__next {
    right: 40px;
  }

  &__prev {
    left: 40px;
  }

  &__next,
  &__prev {
    @media(max-width: 440px) {
      display: none;
    }
  }

  &__viewport {
    max-width: 1140px;
    margin: 0 auto;
    @media (max-width: 1180px) {
      max-width: 860px;
    }
    @media (max-width: 1200px) {
      max-width: 960px;
    }
  }

  &__pagination-button {
    @media (max-width: 768px) {
      --vc-pgn-width: 40px;
      --vc-pgn-height: 40px;
    }
  }
}

/* END CAROUSEL */

main .bg-blue-05 {
  @media (max-width: 768px) {
    background-color: transparent;
  }
}

.tes-articles-main {

  &__header {
    @media (min-width: 992px) {
      max-width: 720px;
    }
    @media (min-width: 1200px) {
      max-width: 1140px;
    }
  }

  &__head {
  }

  &__head_1 {
    margin-bottom: 22px;
    padding-left: 22px;
    line-height: 3rem;
    font-weight: 600;
    font-size: 2.5rem;
    @media(max-width: 485px) {
      font-size: 1.8rem;
      padding-left: 0;
      text-align: center;
    }
  }

  &__head_2 {
    margin: 40px 0 20px;
    line-height: 43px;
    text-align: center;
  }

  &__section {
    margin-bottom: 30px;
  }

  &__section-footer {
    margin: 55px auto 120px;
    text-align: center;
    @media (max-width: 768px) {
      margin: 55px auto 25px;
    }
  }

  &__section-more-link {
    display: inline-block;
    font-weight: 400;
    text-align: center;
    vertical-align: middle;
    padding: 16px 34px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
    font-size: 18px;
    line-height: 21px;
    border-radius: 50px;
    color: #31c5f4;
    border: 4px solid #31c5f4;
    background-color: transparent;
    transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;

    &:hover {
      color: #fff !important;
      background-color: #31c5f4;
    }
  }
}

.tes-articles-main {
  &__first-section {

  }
}

.tes-articles-main {

  &__news-section {
    padding: 0;
  }

  &__news-header {
    text-align: center;
  }

  &__news-container {
    display: flex;
    flex-direction: row;
    justify-content: center;

    @media (max-width: 1200px) {
      flex-wrap: wrap;
    }
    @media (max-width: 768px) {
      flex-wrap: wrap;
    }
  }

  &__news-wrapper {
    height: 375px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: 1200px) {
      height: auto;
      padding: 30px 0;
    }
    @media (max-width: 768px) {
      height: auto;
      padding: 30px 0;
    }
  }

  &__news-item {
    width: 263px;
    height: 255px;
    margin: 0 9px;
    display: flex;
    @media (max-width: 1200px) {
      margin: 9px;
    }
    @media (max-width: 768px) {
      margin: 9px;
    }
  }

  &__news-item-link {
  }

  &__news-item-img {
    aspect-ratio: $newsSlideAspectRatio;
  }

  &__picture-container {
    width: 263px;
    height: 170px;
  }

  &__news-item-title {
    min-height: 88px;
    display: block;
    padding: 1.25rem;
    font-weight: 600;
    margin: 0 0 0.75rem;
    font-size: 1.25rem;
    text-align: center;
    line-height: 1.2;
    color: #46535e;
    background: #fff;
  }
}

.tes-articles-main {
  &__banner-section {
    margin-top: 60px;
    margin-bottom: 50px;
  }
}

.tes-articles-main {
  &__popular-section {
  }

  &__popular-header {
    text-align: center;
  }
}

.tes-articles-main {

  &__pagination {
    margin-top: 15px;
  }

  &__pagination-item {
    padding: 10px 20px;
    font-size: 18px;
    line-height: 21px;
    border-radius: 50px;
    border: 4px solid #31c5f4;
    color: #31c5f4;
    display: inline-block;
  }

  &__pagination-item_delimiter {
    border: none;
    color: #000;
  }

  &__pagination_popular {
  }
}

.tes-articles-main {

  &__tags-section {
    padding: 60px 0 30px;
    margin-bottom: 60px;
  }

  &__tags-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    @media (max-width: 1200px) {
      flex-wrap: wrap;
    }
    @media (max-width: 768px) {

    }
  }

  &__tags-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 60px 0;

    @media (max-width: 768px) {
    }
  }


  &__tag-panel-link {
    position: relative;
    width: 100%;
    display: block;
    margin-bottom: 25px;
    font-weight: 300;
    color: #000;

    &:before {
      content: '>';
      position: absolute;
      left: -15px;
      font-size: 12px;
      font-weight: 600;
    }
  }

  &__tag-panel {

    width: 264px;
    height: 431px;
    overflow: hidden;
    background-color: #fff;
    margin: 10px;
    padding: 30px 18px 30px 38px;
    font-size: 18px;
    line-height: 21px;
    box-shadow: 0 1px 7px rgb(0 0 0 / 16%);
    @media (min-width: 1200px) {
      margin: 9px 9px;
      padding: 30px 18px 30px 38px;
      box-shadow: none;
    }

    &_blue {
      .tes-articles-main__tag-panel-title,
      .tes-articles-main__tag-panel-title-link,
      .tes-articles-main__tag-panel-link:before {
        color: #31c5f4;
      }
    }

    &_green {
      .tes-articles-main__tag-panel-title,
      .tes-articles-main__tag-panel-title-link,
      .tes-articles-main__tag-panel-link:before {
        color: #4fb91b;
      }
    }

    &_brown {
      .tes-articles-main__tag-panel-title,
      .tes-articles-main__tag-panel-title-link,
      .tes-articles-main__tag-panel-link:before {
        color: #8b3535;
      }
    }

    &_darkgreen {
      .tes-articles-main__tag-panel-title,
      .tes-articles-main__tag-panel-title-link,
      .tes-articles-main__tag-panel-link:before {
        color: #367015;
      }
    }

  }
}

.tes-articles-main__tag-panel-title,
.tes-articles-main__tag-panel-title-link,
a.tes-articles-main__tag-panel-title-link:link,
a.tes-articles-main__tag-panel-title-link:visited,
a.tes-articles-main__tag-panel-title-link:active,
a.tes-articles-main__tag-panel-title-link:hover,
.tes-articles-main__tag-panel-title-link .active {
  font-weight: 400;
  margin-bottom: 32px;
  text-align: left;
}

.tes-articles-main__tag-panel-link,
a.tes-articles-main__tag-panel-link:link,
a.tes-articles-main__tag-panel-link:visited,
a.tes-articles-main__tag-panel-link:active,
a.tes-articles-main__tag-panel-link:hover,
a.tes-articles-main__tag-panel-link .active {
  font-weight: 300;
  text-align: left;
  font-size: 18px;
  line-height: 21px;
  color: #000;
}
</style>
